import { HourglassBottom } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';
import React from 'react';

interface AlertCardProps {
    background: string;
    icon: React.ReactNode;
    label: string;
    onClick?: () => void;
    children: JSX.Element;
}
function AlertCard({ background, icon, label, children, onClick }: AlertCardProps) {
    return (
        <Box
            sx={{
                backgroundColor: background,
                borderRadius: 2,
                padding: 1,
                flexGrow: 1,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: 'center',
                minHeight: 80,
                cursor: 'pointer',
            }}
            onClick={onClick}
        >
            {icon}
            <Typography variant="caption" sx={{ fontSize: 11, mt: 0.5 }}>
                {label}
            </Typography>
            <Typography variant="body2" fontWeight="bold">
                {children}
            </Typography>
        </Box>
    );
}

export default AlertCard;